import React from 'react'

const BottomTextSolicitudViolencia = () => {
  return (
    <div className='footer__background text-center flex h-auto p-3 mt-3 mb-3 justify-content-center' >
      La violencia familiar no discrimina. Personas de cualquier raza, edad, género, sexualidad, religión, nivel de escolaridad o situación económica pueden ser víctimas (o generadores) de violencia familiar.
    </div>
  )
}

export {BottomTextSolicitudViolencia}